// extracted by mini-css-extract-plugin
export default {"contactItem":"OJhNTVO0ZbuoFx6SxnGM","title":"kpE4W1ZyHWlg8SG5gjfR"};